__turbopack_context__.v({
  "large": "missing-image-module__cuc1MW__large",
  "mini": "missing-image-module__cuc1MW__mini",
  "text": "missing-image-module__cuc1MW__text",
  "wrapper": "missing-image-module__cuc1MW__wrapper",
});
